"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _core = _interopRequireDefault(require("./core"));

var _jquery = _interopRequireDefault(require("jquery"));

function _classStaticPrivateMethodGet(receiver, classConstructor, method) { _classCheckPrivateStaticAccess(receiver, classConstructor); return method; }

function _classCheckPrivateStaticAccess(receiver, classConstructor) { if (receiver !== classConstructor) { throw new TypeError("Private static access of wrong provenance"); } }

var Mouse = /*#__PURE__*/function () {
  function Mouse() {
    (0, _classCallCheck2["default"])(this, Mouse);
  }

  (0, _createClass2["default"])(Mouse, null, [{
    key: "getPosition",
    value: function getPosition(ev, element) {
      ev = _classStaticPrivateMethodGet(this, Mouse, _getEvent).call(this, ev);
      var rect = {
        left: 0,
        top: 0
      };

      if (element) {
        var $element = element instanceof _jquery["default"] ? element : (0, _jquery["default"])(element);
        var tmpRect = $element.offset();

        if (tmpRect) {
          rect = tmpRect;
        }
      }

      return {
        x: ev.pageX !== undefined ? ev.pageX - rect.left : rect.left,
        y: ev.pageY !== undefined ? ev.pageY - rect.top : rect.top
      };
    }
  }, {
    key: "getElement",
    value: function getElement(ev) {
      ev = _classStaticPrivateMethodGet(this, Mouse, _getEvent).call(this, ev);
      return window.document.elementFromPoint(ev.clientX, ev.clientY);
    }
  }]);
  return Mouse;
}();

function _getEvent(ev) {
  if (_core["default"].isTouchDevice()) {
    var orgEvent = ev.originalEvent ? ev.originalEvent : ev;

    if (orgEvent.changedTouches && orgEvent.changedTouches.length) {
      ev = orgEvent.changedTouches[0];
    } else if (orgEvent.touches) {
      ev = orgEvent.touches[0];
    }
  }

  return ev;
}

var _default = Mouse;
exports["default"] = _default;